module.exports = __webpack_public_path__ + "static/media/sbi.5950a588.svg";